module.exports = __webpack_public_path__ + "static/img/PE.87964481.jpg";